import React, { Component } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import icon from "../../../icon";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import LoadingCircle from "../../../components/Loading/LoadingCircle";

class Material_icons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      icons: icon.icons,
      filtered_icons: [],
      txtSearch: "",
      searching: false
    };

    this.timer = {};
  }

  calculate_score(_search, _text) {
    var score = 0;
    _search = _search.toLowerCase();
    _text = " " + _text.toLowerCase() + " ";
    var words = _search.split(" ");

    for (var i = 0; i < words.length; i++) {
      if (words[i].length > 1) {
        if (_text.indexOf(words[i]) !== -1) {
          score = score + 1;
        }
        if (_text.indexOf(" " + words[i]) !== -1) {
          score = score + 1;
        }
        if (_text.indexOf(" " + words[i] + " ") !== -1) {
          score = score + 1;
        }
      }
    }

    return score;
  }

  runSearch() {
    var filtered_icons = JSON.parse(JSON.stringify(this.state.icons));

    for (var i = 0; i < filtered_icons.length; i++) {
      filtered_icons[i].score = this.calculate_score(
        this.state.txtSearch,
        filtered_icons[i].search
      );
    }

    filtered_icons = filtered_icons.filter(icon => icon.score > 0);

    filtered_icons.sort(function(a, b) {
      return a.score > b.score ? -1 : a.score < b.score ? 1 : 0;
    });

    this.setState({
      filtered_icons: filtered_icons,
      searching: false
    });
  }

  componentWillUnmount() {
    if (this.timer.changeTimerID !== undefined) {
      clearTimeout(this.timer.changeTimerID);
    }
  }

  searchChange(e, event) {
    this.setState({
      txtSearch: event.target.value
    });

    if (event.target.value.length >= 3) {
      this.setState({
        searching: true
      });

      if (this.timer.changeTimerID !== undefined) {
        clearTimeout(this.timer.changeTimerID);
      }
      this.timer.changeTimerID = setTimeout(() => {
        this.runSearch();
      }, 600);
    }
  }

  render() {
    const ICONS = this.state.icons.map(icon => (
      <span
        key={icon.icon}
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 2,
          paddingRight: 2,
          width: 125,
          textAlign: "center",
          display: "inline-block"
        }}
      >
        <i style={{ fontSize: 32 }} className="material-icons">
          {icon.icon}
        </i>
        <br />
        <span
          style={{
            fontSize: 11,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "block",
            width: "100%"
          }}
        >
          {icon.icon}
        </span>
      </span>
    ));

    const ICONS_filtered = this.state.filtered_icons.map(icon => (
      <span
        key={icon.icon}
        style={{
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 2,
          paddingRight: 2,
          width: 125,
          textAlign: "center",
          display: "inline-block"
        }}
      >
        <i style={{ fontSize: 32 }} className="material-icons">
          {icon.icon}
        </i>
        <br />
        <span
          style={{
            fontSize: 11,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "block",
            width: "100%"
          }}
        >
          {icon.icon}
        </span>
      </span>
    ));

    return (
      <div className="row" id="material_icons">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Material Icon Font</h2>
              <p>
                These Materia Design icons are produced by Google and are here
                to add a level of usability and sometimes quirkiness to your
                workflow. It has been our experience that some people will read
                words over icons and others icons over words. We encourage you
                to, where possible add icons and colors to your interface
                design. It will significantly increase your workflows usability.{" "}
              </p>
              <TextField
                label="Search"
                value={this.state.txtSearch}
                onChange={this.searchChange.bind(this, this)}
                margin="normal"
                fullWidth={true}
                placeholder={"What are you looking for?"}
                onKeyPress={ev => {
                  if (ev.key === "Enter") {
                    this.runSearch();
                  }
                }}
                autoFocus={false}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <i
                        className="material-icons"
                        style={{ color: "#000000" }}
                      >
                        search
                      </i>
                    </InputAdornment>
                  )
                }}
              />
              {this.state.txtSearch === "" ? (
                <div>{ICONS}</div>
              ) : (
                <div>
                  {this.state.searching === true ? (
                    <div>
                      <div style={{ paddingTop: 50, paddingBottom: 50 }}>
                        <LoadingCircle />
                      </div>
                    </div>
                  ) : (
                    <div>
                      {ICONS_filtered}
                      {this.state.filtered_icons.length === 0 ? (
                        <div>no results.</div>
                      ) : null}
                    </div>
                  )}
                </div>
              )}
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Material_icons;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Material_icons.js